import {api, headers} from './api';

const RESOURCE = 'jurusan';

export const indexJurusan = () => api.get(RESOURCE, headers);

export const storeJurusan = (data) => api.post(RESOURCE, data, headers);